var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-2",attrs:{"outlined":"","tile":""}},[_c('h4',[_vm._v("Statistika učlanjivanja")]),(!_vm.loading && Object.keys(_vm.memberActivationStats).length !== 0)?_c('div',[_c('v-select',{staticClass:"year-selector",attrs:{"items":_vm.membershipYears,"dense":""},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}}),_c('Bar',{attrs:{"chart-options":{
        responsive: true,
        backgroundColor: '#1976d2',
        plugins: {
          legend: {
            display: false,
          },
        },
      },"chart-data":_vm.chartData,"height":_vm.chartHeight}})],1):_vm._e(),(!_vm.loading && Object.keys(_vm.memberActivationStats).length !== 0)?_c('div',[_c('Bar',{attrs:{"chart-options":{
        responsive: true,
        backgroundColor: '#1976d2',
        plugins: {
          legend: {
            display: false,
          },
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
            },
          },
        },
        scales: {
          x: {
            min: _vm.minYear,
          },
        },
      },"chart-data":_vm.chartDataWholeHistory,"height":_vm.chartHeight}})],1):_vm._e(),(_vm.loading)?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#1358a3"}})],1):_vm._e(),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"error-text"},[_vm._v(_vm._s(_vm.error))])])}
var staticRenderFns = []

export { render, staticRenderFns }